var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIglooLogoPinge1 = function SvgIglooLogoPinge1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#igloo-logo-pinge_1_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 4.838v11.65h11.65c2.4 0 4.345-1.944 4.345-4.343V.495H4.345A4.343 4.343 0 0 0 0 4.837Zm11.595 10.19a2.9 2.9 0 1 1 0-5.799 2.9 2.9 0 1 1 0 5.8Zm2.916-13.063v5.83H8.68c0-3.219 2.61-5.83 5.83-5.83Zm-7.211 0v13.066H1.45V4.885a2.919 2.919 0 0 1 2.92-2.92H7.3Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "igloo-logo-pinge_1_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(0 .494)",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgIglooLogoPinge1;